import Agreement from './agreements';
import Page from './page/ContractDetailsPage';
import Wrapper from './wrapper/ContractAgreementDetailWrapper';

export default { Page, Wrapper, Agreement };
